import React from 'react'

const Logo = () => {
  return (
    <>
        <div className="logo-section">
            <div className="logo-data">
            <a href="/"><img src="/logo/ampstekpaylogo.png" alt="Company Logo" /></a>
            </div>
            <div className="logo-title">
              <a href="/">Ampstek Pay</a>
            </div>
        </div>
    </>
  )
}

export default Logo